import { PontuacaoCnhContainer } from "../pontuacao-cnh/PontuacaoCnh.container";
export var AppRoutes = {
    "/": PontuacaoCnhContainer,
};
